import type { FormItem } from 'form/types';

const step: FormItem[] = [
  {
    type: 'input',
    label: 'Full name',
    id: 'name'
  },
  {
    type: 'spacer',
    label: '',
    id: 'sp1'
  },
  {
    type: 'input',
    label: 'Email',
    id: 'email',
    inputType: 'email'
  },
  {
    type: 'spacer',
    label: '',
    id: 'sp2'
  },
  {
    type: 'phone',
    label: 'Phone number',
    id: 'phoneNumber'
  },
  {
    type: 'spacer',
    label: '',
    id: 'sp3'
  },
  {
    type: 'input',
    label: 'Business name',
    id: 'businessName'
  },
  {
    type: 'spacer',
    label: '',
    id: 'sp4'
  },
  {
    type: 'address',
    label: 'Head office address',
    id: 'officeAddress'
  },
  {
    type: 'spacer',
    label: '',
    id: 'sp5'
  },
  {
    type: 'address',
    label: 'Worksite address',
    id: 'siteAddress'
  },
  {
    type: 'spacer',
    label: '',
    id: 'sp6'
  },
  {
    type: 'input',
    label: 'Registered practitioner licence (if applicable)',
    id: 'practitionerLicense',
    placeholder: 'e.g DB-U 123',
    hint: 'Your registered building practitioner number of the site operator'
  },
  {
    type: 'spacer',
    label: '',
    id: 'sp7'
  },
  {
    type: 'input',
    id: 'permitNumber',
    label: 'Building permit number (if applicable)',
    hint: 'Your 13-digit building permit number',
    placeholder: 'e.g 6789/20140001/0',
    inputType: 'tel',
    maskingOptions: {
      formatChars: {
        x: '[0-9]'
      },
      mask: 'xxxx/xxxxxxxx/x'
    }
  },
  {
    type: 'spacer',
    label: '',
    id: 'sp8'
  },
  {
    type: 'dropdown',
    id: 'buildingClass',
    label: 'Building class',
    hint: 'Building classifications under the National Construction Code (NCC)',
    options: [
      "My site doesn't have a designated Building Class",
      'Class 1a',
      'Class 1b',
      'Class 2',
      'Class 3',
      'Class 4',
      'Class 5',
      'Class 6',
      'Class 7a',
      'Class 7b',
      'Class 8',
      'Class 9a',
      'Class 9b',
      'Class 9c',
      'Class 10a',
      'Class 10b',
      'Class 10c'
    ].map(str => ({ label: str, value: str }))
  },
  {
    type: 'spacer',
    label: '',
    id: 'sp11'
  },
  {
    type: 'input',
    id: 'abn',
    label: 'ABN',
    hint: 'Your 11-digit Australian Business Number',
    inputType: 'tel',
    placeholder: 'e.g 12 345 678 890',
    maskingOptions: {
      formatChars: {
        x: '[0-9]'
      },
      mask: 'xx xxx xxx xxx'
    },
    disabled: false
  },
  {
    type: 'checkbox',
    id: 'ownerBuilder',
    label: "I'm an owner-builder and don't need an ABN"
  },
  {
    type: 'spacer',
    label: '',
    id: 'sp9'
  },
  {
    type: 'uppercaseInput',
    id: 'locationShortCode',
    label: 'QR code (Location Code)',
    hint: 'This Location Code is below your QR code on your poster',
    placeholder: 'e.g 2XY 979',
    maskingOptions: {
      formatChars: {
        x: '[a-zA-Z0-9]'
      },
      mask: 'xxx xxx'
    }
  },
  {
    type: 'spacer',
    label: '',
    id: 'sp10'
  }
];

export default step;
